const Colors = {
  primary: '#2B378F',
  white: '#ffffff',
  primaryOpacity: '#3F51B5',
};

export default Colors;
